import React, { useState, useEffect } from 'react';

/**
 * @description Formulario para crear o editar un proyecto.
 * Si se proporciona un `project` en las props, el formulario se inicializa con sus datos para edición.
 * De lo contrario, se muestra vacío para la creación de un nuevo proyecto.
 * @param {object} props Las propiedades del componente.
 * @param {object} [props.project] El objeto del proyecto a editar. Opcional.
 * @param {Function} props.onSave Callback que se ejecuta al enviar el formulario con los datos del proyecto.
 * @param {Function} props.onCancel Callback que se ejecuta al pulsar el botón de cancelar.
 * @returns {JSX.Element}
 */
const ProjectForm = ({ project, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [client_name, setClientName] = useState('');
  const [client_phone, setClientPhone] = useState('');
  const [client_email, setClientEmail] = useState('');

  // Efecto para rellenar el formulario cuando se pasa un proyecto para editar.
  useEffect(() => {
    if (project) {
      setName(project.name || '');
      setAddress(project.address || '');
      setClientName(project.client_name || '');
      setClientPhone(project.client_phone || '');
      setClientEmail(project.client_email || '');
    } else {
      // Limpia el formulario si no hay proyecto (ej. al cerrar un modal de edición y abrir uno de creación)
      setName('');
      setAddress('');
      setClientName('');
      setClientPhone('');
      setClientEmail('');
    }
  }, [project]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, address, client_name, client_phone, client_email });
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="project-name">Nombre del proyecto</label>
        <input
          id="project-name"
          className="modal-field"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Torre Norte"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="project-address">Dirección</label>
        <input
          id="project-address"
          className="modal-field"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Ej: Av. Siempre Viva 742"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="project-client-name">Nombre del cliente</label>
        <input
          id="project-client-name"
          className="modal-field"
          value={client_name}
          onChange={(e) => setClientName(e.target.value)}
          placeholder="Ej: Constructora ABC"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="project-client-phone">Teléfono del cliente</label>
        <input
          id="project-client-phone"
          className="modal-field"
          value={client_phone}
          onChange={(e) => setClientPhone(e.target.value)}
          placeholder="Ej: +54 9 11 1234-5678"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="project-client-email">Email del cliente (opcional)</label>
        <input
          id="project-client-email"
          type="email"
          className="modal-field"
          value={client_email}
          onChange={(e) => setClientEmail(e.target.value)}
          placeholder="cliente@empresa.com"
        />
      </div>

      <div className="modal-footer">
        <button type="button" onClick={onCancel} className="modal-btn-secondary">Cancelar</button>
        <button type="submit" className="modal-btn-primary">Guardar</button>
      </div>
    </form>
  );
};

// El gap entre campos vive acá porque Modal.js solo controla el espaciado
// de su único hijo directo (el <form>).
const styles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
};

export default ProjectForm;
